// Safe clickable links (gap #12). Only http and https ever become links; a bare domain like
// "wildstem.com" gets https:// added. Anything else (javascript:, data:, mailto:, plain words) stays text.
export function safeHref(input) {
  let s = String(input == null ? "" : input).trim();
  if (!s || s.length > 2048 || /[\s<>"'`\\]/.test(s)) return null;
  if (/^[a-z][a-z0-9+.-]*:/i.test(s) && !/^https?:\/\//i.test(s)) return null;   // some other scheme
  if (/^\/\//.test(s)) s = "https:" + s;
  else if (!/^https?:\/\//i.test(s)) {
    if (!/^[a-z0-9-]+(\.[a-z0-9-]+)+(:\d{1,5})?([/?#]|$)/i.test(s)) return null;  // not a domain
    s = "https://" + s;
  }
  let u;
  try { u = new URL(s); } catch (e) { return null; }
  if (u.protocol !== "http:" && u.protocol !== "https:") return null;
  if (!/\.[a-z]{2,}$/i.test(u.hostname) || u.username || u.password) return null;
  return u.href;
}
